import React from "react";

import AppliedCalenderRedirectButton from "./AppliedCalenderRedirectButton";

const CandidateProfileCalenderDateUi = ({ _calObj, value, calDateObj }) => {
  return (
    <div className="grid h-[48px] w-[48px] place-items-center">
      <div
        className={`relative z-[1] h-[40px] w-[40px] bg-gradient-to-b text-[18px] font-medium leading-[40px]`}
      >
        <div className="absolute left-[1px] top-[1px] flex h-[38px] w-[38px] flex-col overflow-hidden rounded-lg">
          {_calObj.Published > 0 && (
            <span className="block flex-1 bg-red"></span>
          )}
          {_calObj.Applied > 0 && (
            <>
              <AppliedCalenderRedirectButton
                calDateObj={calDateObj}
                btnClass={
                  "block flex-1 bg-yellow cursor-pointer text-white hover:text-white"
                }
                value={value}
              />
            </>
          )}
          {_calObj.Available > 0 &&
            _calObj.Applied == 0 &&
            _calObj.Booked == 0 && (
              <span className="block flex-1 bg-blue"></span>
            )}
          {_calObj.Booked > 0 && (
            <span className="block flex-1 bg-green"></span>
          )}
        </div>

        {_calObj.Applied > 0 ? null : (
          <span
            className={`relative ${Object.values(_calObj).every((ele) => ele == 0) ? "text-txtColor" : "text-white"}`}
          >
            {value.$D}
          </span>
        )}
      </div>
    </div>
  );
};

export default CandidateProfileCalenderDateUi;
